import React from 'react';
import { Box, KeyValue } from 'web-library';
import { useTranslation } from 'react-i18next';
import { OopAdminResitRegistrationDetails } from '../../../../api/candidate/resit/@opadmin/models';
import FormHeader from '../../../../components/form-items/FormHeader';

export interface RegisteredCandidateDetailsProps{
  candidateDetail: OopAdminResitRegistrationDetails
}

const RegisteredCandidateDetails: React.FC<RegisteredCandidateDetailsProps> = (props: RegisteredCandidateDetailsProps) => {
  const { candidateDetail } = props;
  const { t } = useTranslation();

  return (<Box>
      <FormHeader title={t('resit->>OpAdminResit.Candidate Registration Details')} />

      <KeyValue
        keyText={t('resit->>OpAdminResit.ID Type (NRIC/FIN or Passport No.)')}
        valueText={candidateDetail.idType}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.NRIC/FIN/Passport No.')}
        valueText={candidateDetail.id}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Index No.')}
        valueText={candidateDetail.indexNumber}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Statutory Name')}
        valueText={candidateDetail.statutoryName}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Exam Level')}
        valueText={candidateDetail.examLevel}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Subject Code')}
        valueText={candidateDetail.subjectCode}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Subject Name')}
        valueText={candidateDetail.subjectName}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Email')}
        valueText={candidateDetail.email}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Phone No.')}
        valueText={candidateDetail.phoneNumber}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Mobile No.')}
        valueText={candidateDetail.mobileNumber}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Mailing Address')}
        valueText={candidateDetail.mailingAddress}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.School Code Desc')}
        valueText={candidateDetail.school}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Application Date')}
        valueText={candidateDetail.applicationDate}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.CP Reference No.')}
        valueText={candidateDetail.cpReferenceNumber}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Payment Date/Time')}
        valueText={candidateDetail.paymentDateTime}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Payment Mode')}
        valueText={candidateDetail.paymentMode}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Collection Agency')}
        valueText={candidateDetail.collectionAgency}
      />

      <KeyValue
        keyText={t('resit->>OpAdminResit.Transaction Reference No.')}
        valueText={candidateDetail.transactionNumber}
      />

      <KeyValue
        capitalize={false}
        keyText={t('resit->>OpAdminResit.Exam Fee (with GST)')}
        valueText={`S$${candidateDetail.examFee}`}
      />

    </Box>
  )
}
export default RegisteredCandidateDetails;
